
<main>
    <div class="jobs">
        <h4>કાર્યક્રમ યાદી</h4>
        <hr>
        <div class="filtering">
            <form>
                <input placeholder="શોધો..." type="search" #filter (keyup)="applyFilter($event)" class="form-control"
                    aria-label="Search box">
                <i class="ti ti-search"></i>
            </form>
        </div>
        <div>
            <div class="main-members">
                <a class="member-list-item" *ngFor="let data of getEventList">
                    <div class="flex1" (click)="goToSubEvent(data.event_id)">
                        <h5>{{data.event_name}}</h5>
                    </div>
                </a>
            </div>
        </div>
    </div>
</main>